var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.96155 9H22.0069","stroke":"#2D2927","strokeWidth":"1.67382","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.96155 14.9596H22.0069","stroke":"#2D2927","strokeWidth":"1.67382","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.96155 20.9192H22.0069","stroke":"#2D2927","strokeWidth":"1.67382","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Menu.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
